// extracted by css-extract-rspack-plugin
module.exports =  {"root":"JobCreation__root___Bf4KL"};